import React, {useState, useEffect, useRef} from "react";

import "./Fading.css";

export default function TextVideo(props) {
  const height= window.innerHeight;
  const width= window.innerWidth;


  const ref= useRef();
  
  useEffect(() => {
    const height= window.innerHeight;
  }, []);

  const json_object = JSON.parse(props.textVideo)
  return (
    props.isMobile ? (
    <div  style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black", 
        }}>
      <video
           preload="auto"
           loop={true}
           muted = {true}
           defaultMuted
           autoPlay={true}
           playsInline={true}
           width={width}
           src={json_object.src}
           onLoad={()=>{this.player.seek(0)}} 
        poster = {json_object.poster}
        />
    </div>)
    : (
      <div  style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black", 
        height: "100vh",
        width: "100vw",
        }}>
      <video
        preload="auto"
        loop={true}
        muted = {true}
        defaultMuted
        autoPlay={true}
        playsInline={true}
        height={height}
        src={json_object.src}
        onLoad={()=>{this.player.seek(0)}} 
        />
    </div>
    )
    )
}
